import { useMutation } from "react-query";
import Login from "../../components/login/Login";
import { useNavigate } from "react-router-dom";
import { signInUser } from "../../api";
import { useState } from "react";
import { signItem } from "../../states/atoms/signState";
import { useRecoilState } from "recoil";
import { useMount } from "react-use";

const LoginPage = () => {
  const navigate = useNavigate();
  const [{ result }, setSignIn] = useRecoilState(signItem);
  const [error, setError] = useState("");
  const { mutate: onLogin } = useMutation({
    mutationFn: signInUser,
    onSettled: (data, err) => {
      const { result, data: item, error } = data;
      if (result) {
        setSignIn({ result, info: item, error: null });
        const { token, role } = item;
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        switch (role) {
          case "student":
            return navigate("/student");
          case "parent":
            return navigate("/parent");
          default:
            return navigate("/lecture");
        }
      }
      if (err) {
        setError(err);
      }
      setError(error);
    },
  });

  useMount(() => {
    localStorage.removeItem("tmp");
  });
  return <>{!result && <Login {...{ onLogin, setError, error }} />}</>;
};

export default LoginPage;
